/* eslint-disable import/export */
/* eslint-disable no-underscore-dangle */
import * as React from 'react';
var _cloneElement = function (props, element) {
    return React.isValidElement(element)
        ? React.cloneElement(element, props)
        : element;
};
export function cloneElement(props, element) {
    if (!element)
        return function (_element) {
            return _cloneElement(props, _element);
        };
    return _cloneElement(props, element);
}
//# sourceMappingURL=cloneElement.js.map